/** Connector-token admin endpoints (Settings › Integrations). The raw token is
 * returned once on mint and never stored client-side beyond the confirm view. */

import { apiFetch } from "@/lib/api";

interface Envelope<T> {
  data: T;
}

export async function getConnectorTokenStatus(): Promise<{ configured: boolean }> {
  const { data } = await apiFetch<Envelope<{ configured: boolean }>>(
    "/eservices/connector/token/",
  );
  return data;
}

export async function mintConnectorToken(): Promise<{ token: string }> {
  const { data } = await apiFetch<Envelope<{ token: string }>>(
    "/eservices/connector/token/",
    { method: "POST" },
  );
  return data;
}
